/**
 * Patches localStorage.setItem so that any write to an attempt key
 * (hld-attempt-* or lld-attempt-*) dispatches an 'attemptDataUpdated' event.
 *
 * This lets HLDDocument and LLDDocument update in real-time whenever any
 * component saves progress — without touching every write site.
 */
const _origSetItem = localStorage.setItem.bind(localStorage);

localStorage.setItem = function patchedSetItem(key, value) {
  _origSetItem(key, value);
  if (
    typeof key === 'string' &&
    (key.startsWith('hld-attempt-') || key.startsWith('lld-attempt-'))
  ) {
    window.dispatchEvent(new CustomEvent('attemptDataUpdated', { detail: { key } }));
  }
};
